module.exports = __webpack_public_path__ + "static/media/3.Rain Gun Prime.1466775b.jpeg";